import React from 'react';
import { GlyphMark } from './GlyphMark.jsx';
import { TokenPill } from './TokenPill.jsx';

const BADGES = {
  done: { text: 'DONE', color: 'var(--bujo-state-done)' },
  cancelled: { text: 'CANC', color: 'var(--bujo-state-cancelled)' },
  migrated: { text: 'MIGR', color: 'var(--bujo-state-migrated)' }
};

const TEXT_COLOR = {
  open: 'var(--bujo-text-primary)',
  note: 'var(--bujo-text-primary)',
  question: 'var(--bujo-text-primary)',
  event: 'var(--bujo-text-primary)',
  done: 'var(--bujo-text-dim)',
  migrated: 'var(--bujo-text-dim)',
  cancelled: 'var(--bujo-state-cancelled)'
};

/** One rapid-log entry. The single row shape used by the daily log, filters and collections. */
export function EntryRow({
  state = 'open', text, priority = false, selected = false, queued = false,
  tokens = [], meta, badge = true, divider = true, onClick, style
}) {
  const showBadge = badge && BADGES[state];
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex', gap: 'var(--bujo-space-2)', alignItems: 'flex-start',
        minHeight: 'var(--bujo-row-min)', padding: '6px 0',
        borderBottom: divider ? '1px solid var(--bujo-rule-hairline)' : 'none',
        background: selected ? 'var(--bujo-select-ground)' : 'transparent',
        boxShadow: selected ? 'inset var(--bujo-select-edge-width) 0 0 var(--bujo-select-edge)' : 'none',
        paddingLeft: selected ? 'var(--bujo-space-2)' : 0,
        marginLeft: selected ? 'calc(var(--bujo-space-2) * -1)' : 0,
        cursor: onClick ? 'pointer' : 'default',
        ...style
      }}>
      <GlyphMark state={selected ? 'selected' : state} priority={priority && !selected}
        style={{ paddingTop: 2 }} />
      <span style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0 }}>
        <span style={{
          font: 'var(--bujo-fw-regular) var(--bujo-fs-entry)/var(--bujo-lh-row) var(--bujo-font-mono)',
          color: TEXT_COLOR[state] || TEXT_COLOR.open,
          textDecoration: state === 'cancelled' ? 'line-through' : 'none',
          textWrap: 'pretty'
        }}>
          {selected && priority ? (
            <span style={{ color: 'var(--bujo-state-priority)', fontWeight: 'var(--bujo-fw-bold)' }}>! </span>
          ) : null}
          {text}
        </span>
        {(meta || tokens.length) ? (
          <span style={{
            display: 'flex', flexWrap: 'wrap', gap: 'var(--bujo-space-2)', alignItems: 'baseline',
            font: 'var(--bujo-fw-regular) var(--bujo-fs-meta)/var(--bujo-lh-tight) var(--bujo-font-mono)',
            color: 'var(--bujo-text-meta)'
          }}>
            {meta ? <span>{meta}</span> : null}
            {tokens.map((t, i) => <TokenPill key={i} kind={t.kind} name={t.name} />)}
          </span>
        ) : null}
      </span>
      {queued ? (
        <span style={{
          font: 'var(--bujo-fw-regular) var(--bujo-fs-micro)/var(--bujo-lh-tight) var(--bujo-font-mono)',
          color: 'var(--bujo-state-queued)', flex: 'none', paddingTop: 2
        }}>&#8961; queued</span>
      ) : showBadge ? (
        <span style={{
          font: 'var(--bujo-fw-bold) var(--bujo-fs-badge)/var(--bujo-lh-tight) var(--bujo-font-mono)',
          letterSpacing: 'var(--bujo-ls-badge)', color: showBadge.color, flex: 'none', paddingTop: 4
        }}>{showBadge.text}</span>
      ) : selected ? (
        <span style={{
          font: 'var(--bujo-fw-bold) var(--bujo-fs-badge)/var(--bujo-lh-tight) var(--bujo-font-mono)',
          letterSpacing: 'var(--bujo-ls-badge)', color: 'var(--bujo-select-edge)', flex: 'none', paddingTop: 4
        }}>SEL</span>
      ) : null}
    </div>
  );
}
